var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOutlinePaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.286,
    height: 11.984,
    viewBox: "0 0 10.286 11.984",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Light-Outline_Paper",
    "data-name": "Iconly/Light-Outline/Paper",
    transform: "translate(-3.001 -2)",
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("g", {
    id: "Paper",
    transform: "translate(3.001 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M6.621,0A.455.455,0,0,1,6.7.007H6.78a.454.454,0,0,1,.326.139l3.055,3.183a.452.452,0,0,1,.126.313V9.172A2.785,2.785,0,0,1,7.6,11.983H2.7A2.766,2.766,0,0,1,0,9.292V2.709A2.774,2.774,0,0,1,2.758.007H6.545A.455.455,0,0,1,6.621,0ZM6.169.912H2.759A1.862,1.862,0,0,0,.906,2.72V9.172a1.862,1.862,0,0,0,1.815,1.907H7.586a1.882,1.882,0,0,0,1.8-1.9V4.213H8.17a2.01,2.01,0,0,1-2-2.006Zm.34,6.694a.452.452,0,0,1,0,.9H3.251a.452.452,0,0,1,0-.9ZM5.275,5.343a.452.452,0,1,1,0,.9H3.251a.452.452,0,1,1,0-.9Zm1.8-3.923v.788a1.1,1.1,0,0,0,1.1,1.1h.715Z",
    transform: "translate(-0.001 0)",
    fill: "#1b2737",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlinePaper);
export default __webpack_public_path__ + "static/media/OutlinePaper.1e2892f33c9737b9596f187969aac3d1.svg";
export { ForwardRef as ReactComponent };